import { render, staticRenderFns } from "./queryBtns.vue?vue&type=template&id=125fd016&"
import script from "./queryBtns.vue?vue&type=script&lang=js&"
export * from "./queryBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports